import React, { useEffect, useState } from 'react';
import { ToastManager } from './ToastManager';
import { Toast, type TToastProps } from './Toast';
import { StyledToastContainer } from './Toast.styles';

const TOAST_DURATION = 5000;

export type TToast = Omit<TToastProps, 'onDismiss'> & { duration?: number | null };

export const ToastContainer = () => {
    const [toasts, setToasts] = useState<Omit<TToast, 'duration'>[]>([]);

    useEffect(() => {
        const unsubscribe = ToastManager.subscribe(({ duration = TOAST_DURATION, ...toast }) => {
            setToasts(prevToasts => [...prevToasts, toast]);

            if (duration === null) return;

            setTimeout(() => {
                setToasts(prevToasts => prevToasts.filter(prevToast => prevToast.id !== toast.id));
            }, duration);
        });

        return unsubscribe;
    }, [toasts]);

    const handleDismiss = (id: string) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    };

    return (
        <StyledToastContainer>
            {toasts.map(toast => (
                <Toast key={ toast.id } { ...toast } onDismiss={ handleDismiss } />
            ))}
        </StyledToastContainer>
    );
};

